import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section id="articles" className="relative py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-primary-100 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full mb-3 whitespace-nowrap">
            SEO Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Sugargoo Spreadsheet Expert Guides
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Deep-dive articles covering everything from shipping strategies and discount codes to category-specific buying guides. Built to help you shop smarter.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all duration-200 flex flex-col"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.imageAlt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={article.title}
                />
                <div className="absolute top-3 left-3">
                  <span className="bg-background-50/90 backdrop-blur-sm text-foreground-800 text-[10px] font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="flex flex-col flex-1 p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 line-clamp-2 leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between pt-3 border-t border-background-200/50">
                  <span className="text-[11px] text-foreground-500 flex items-center gap-1 whitespace-nowrap">
                    <i className="ri-time-line text-xs"></i>
                    {article.readTime}
                  </span>
                  <span className="text-xs font-semibold text-primary-600 flex items-center gap-1 group-hover:gap-2 transition-all whitespace-nowrap">
                    Read Article
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}